<template>
  <TransitionRoot as="template" :show="shouldPresent">
    <Dialog class="relative z-10" @close="dismiss">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>
      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
              <div>
                <div class="mx-auto flex items-center justify-center">
                  <LoadingIcon class='w-8 h-8' />
                </div>
                <div class="mt-3 text-center sm:mt-5">
                  <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900">
                    <slot name='title' />
                  </DialogTitle>
                  <div class="mt-2 text-sm text-gray-500">
                    <slot name='message' />
                  </div>
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>

import { ref, computed, watch } from 'vue';
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue';
import { CheckIcon } from '@heroicons/vue/24/outline';

import LoadingIcon from '@/components/icons/loading-icon.vue';

const props = defineProps({
  controller: Object,
  isPresenting: Boolean,
  delayPresentation: {
    type: Number,
    default: 1000
  }
});

const dismiss = () => {
  props.controller.dismiss();
}

const delayTimeout = ref(false);

const isPresenting = computed(() => {
  if (props.controller) {
    return props.controller.isPresenting();
  } else {
    return props.isPresenting;
  }
});

const shouldPresent = computed(() => {
  if (!props.delayPresentation) {
    return isPresenting.value;
  }
  
  return isPresenting.value && delayTimeout.value;
});

watch(isPresenting, () => {
  if (props.delayPresentation) {
    setTimeout(() => {
      delayTimeout.value = true;
    }, props.delayPresentation);
  }
});

</script>